@if (!isForm && !isUploaded) {
  <div class="body-main">
    <!-- Header Bar Labels -->
    <div class="bar-header">
      <div class="bar-title">
        {{ "switch.title" | translate }}
      </div>
      <div class="bar-description">
        @if (!isDetail) {
          <div class="bar-description-text">
            <p>{{ "switch.description" | translate }}</p>
          </div>
        }
        @if (isDetail) {
          <div class="bar-description-text">
            <p>{{ "switch.description-detail" | translate }}</p>
            <h2 class="back" (click)="switchDetail()">
              {{ "switch.subtitle" | translate }}
              <span class="span-black">/</span>
            </h2>
          </div>
        }
      </div>
    </div>
    <div class="page-content">
      @if (!isDetail) {
        <app-manager-list
          [displayObjects]="provisioningStates"
          [properties]="provisioningProperties"
          (changeFilter)="changeFilter($event)"
          (changePage)="changePage($event)"
          [addElementEnabled]="false"
          [switchEnabled]="true"
          (add)="triggerForm()"
          [maxItems]="numberOfProvisioningStates"
          (loadFile)="loadFile($event)"
          [referenceType]="formConfig.name"
          (changeUploadMode)="changeUploadMode('Change')"
          [hasModalUpload]="true"
          [hasDownload]="true"
          [uploadMode]="uploadMode"
          (downloadFile)="downloadLoading('ViewProvisioningState')"
          [service]="provisioningControllerService"
          [filterDownload]="provisioningRequestParameter"
          [isSwitch]="true"
          (selectElement)="getProvisioningStatesById($event)"
        ></app-manager-list>
      }
      @if (isDetail) {
        <app-manager-list
          [displayObjects]="detailProvisioningStates"
          [properties]="detailProvisioningProperties"
          (changeFilter)="changeDetailFilter($event)"
          (changePage)="changeDetailPage($event)"
          [maxItems]="numberOfDetailProvisioningStates"
          [addElementEnabled]="false"
          [hasDownload]="true"
          [referenceType]="'ProvisioningState'"
          (downloadFile)="downloadLoading('ProvisioningState')"
          [service]="provisioningControllerService"
          [filterDownload]="detailProvisioningRequestParameter"
          [deviceId]="selectedProvisioningState.deviceId"
        ></app-manager-list>
      }
    </div>
  </div>
}
@if (isForm && !isUploaded) {
  <div class="switch-form-menu">
    @if (isForm) {
      <div class="form-device-list">
        @if (isForm) {
          <div class="form">
            <div class="top-part">
              <div class="header-form">
                <h2>{{ "manager.Devices.title" | translate }}</h2>
                <p>{{ "manager.Devices.information" | translate }}</p>
              </div>
              @for (
                input of formConfig.inputs;
                track input.property;
                let i = $index
              ) {
                <div class="main-section-item">
                  <div class="label-item">
                    <div class="label-text">
                      {{
                        "manager.inputs." + input.title + ".title" | translate
                      }}
                    </div>
                    @if (input.mandatory) {
                      <div class="label-input-mandatory">*</div>
                    }
                    @if (input.valid === false) {
                      <div class="property-error">
                        -
                        {{
                          input.errorMsg
                            ? input.errorMsg
                            : ("manager.inputs." + input.title + ".errorMsg"
                              | translate)
                        }}
                      </div>
                    }
                  </div>
                  @if (input.search_selector) {
                    <div
                      [class]="
                        input.valid === false
                          ? 'selector-error'
                          : 'selector-type'
                      "
                      [matMenuTriggerFor]="ItemMenu"
                      (menuOpened)="changeArrow(input)"
                      (menuClosed)="changeArrow(input)"
                    >
                      <div class="selector">
                        <div class="list-box">
                          <div class="list-box-label">
                            @if (input.search_selector) {
                              <input
                                class="search_selector_input"
                                [type]="text"
                                [placeholder]="
                                  'Filter ' + (input.title | translate)
                                "
                                [ngModel]="input.filter"
                                (ngModelChange)="input.filter = $event"
                                (input)="onFilterChange(input)"
                              />
                            }
                          </div>
                          <div class="menu-icon">
                            <mat-icon>
                              {{
                                input.isOpen
                                  ? "keyboard_arrow_up"
                                  : "keyboard_arrow_down"
                              }}
                            </mat-icon>
                          </div>
                        </div>
                      </div>
                      <div class="bottom-border"></div>
                      <mat-menu class="form-menu" #ItemMenu="matMenu">
                        <div
                          class="scroll"
                          [infiniteScroll]="loadMore"
                          [scrollRatio]="0.66"
                          [initScrollThreshold]="100"
                        >
                          <div class="menu-holder">
                            @for (
                              choice of input.filteredOptions;
                              track $index;
                              let isFirst = $first
                            ) {
                              <div
                                class="choice"
                                (click)="
                                  input.property === 'deviceIds'
                                    ? $event.stopPropagation()
                                    : null
                                "
                              >
                                @if (
                                  input.search_selector &&
                                  input.filteredOptions.length
                                ) {
                                  <div
                                    [class]="
                                      isFirst ? 'first-choice' : 'choice-button'
                                    "
                                    (click)="
                                      selectProp(
                                        choice,
                                        input.property,
                                        i,
                                        input
                                      )
                                    "
                                  >
                                    <span>{{ choice }}</span>
                                  </div>
                                }
                              </div>
                            }
                            @if (
                              input.search_selector &&
                              !input.filteredOptions.length
                            ) {
                              <div class="empty-choice">
                                <span>{{ "misc.empty" | translate }}</span>
                              </div>
                            }
                          </div>
                        </div>
                      </mat-menu>
                    </div>
                  }
                </div>
              }
              <div [ngStyle]="{ color: '#aaaaaa' }" class="requiredFields">
                <span>*</span>
                {{ "manager.form.requiredFields" | translate }}
              </div>
            </div>
            @if (isForm && !isUploaded) {
              <div class="buttons-form">
                <app-button
                  class="button-cancel"
                  [labelPath]="'misc.cancel' | translate"
                  type="outlined"
                  (clicked)="triggerForm()"
                ></app-button>
                <app-button
                  class="button-apply"
                  [labelPath]="'misc.apply' | translate"
                  type="filled"
                  (clicked)="updateDataFromForm()"
                  [disabled]="!isFormValid"
                ></app-button>
              </div>
            }
          </div>
        }
        @if (isForm) {
          <div class="deviceId-list">
            <div class="top-list">
              <h2 [innerHTML]="translatedTitle"></h2>
              <app-button
                [labelPath]="'manager.Devices.delete' | translate"
                type="filled"
                [iconLeft]="'delete'"
                [disabled]="!deviceIds.length"
                (clicked)="deleteList()"
              ></app-button>
            </div>
            <div class="devices">
              @if (!deviceIds.length) {
                <p class="empty-list">
                  {{ "manager.Devices.emptyList" | translate }}
                </p>
              }
              @for (device of deviceIds; track i; let i = $index) {
                <div class="device">
                  <p>{{ device }}</p>
                  <app-button
                    [iconLeft]="'close'"
                    (clicked)="deleteDevice(i)"
                  ></app-button>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
}
@if (isUploaded) {
  <app-file-uploader
    [datas]="uploadDatas"
    [properties]="properties[typeSelected]"
    [fileName]="fileName"
    [referenceSummary]="referenceSummary"
    uploaderType="reference"
    [columnNames]="columnNames"
    [separatorError]="separatorError"
    [separatorErrorWarnings]="separatorErrorWarnings"
    (goBack)="backOnList()"
    (doProvisioning)="doProvisioning($event)"
  >
  </app-file-uploader>
}
